import React from 'react';
import { Redirect } from 'react-router-dom';

export const PrivateRoute = () => {
  let user = localStorage.getItem("authUser");
  if (!user) return (<Redirect to={'/'} />)
  user = JSON.parse(user);
  console.log('====debugger====== ', user)
  const { level } = user;
  // ... Admin @level 1000
  if (level === 1000) return (<Redirect to={'/dashboard'} />)
  // ... Organization Admin @level 300
  // if (level === 300) return (<Redirect to={`/institutions/${organization_id}`} />)
  if (level === 300) return (<Redirect to={`/user/organizations`} />)
  // ... Institution Admin @level 250
  // if (level === 250) return (<Redirect to={`/teams/${institution_id}`} />)
  if (level === 250) return (<Redirect to={`/user/institutions`} />)
  // ... Team Admin @level 200
  // if (level === 200) return (<Redirect to={`/team/players/${team_id}`} />)
  if (level === 200) return (<Redirect to={`/user/teams`} />)
  // ... player  @level 100
  if (level === 100) return (<Redirect to={`/player/dashboard/${user._id}`} />)

  if (level === 150) return (<Redirect to={`/family/${user._id}`} />)

  return (
    <Redirect to={'/dashboard'} />
  )

}